export default __webpack_public_path__ + "static/media/10-small.ab9b80df.png";